import React from 'react'
import { useDispatch, useSelector} from 'react-redux'
import {togglePopUp} from '../utils/detailsSlice'
import useMovieVidios from '../hooks/useMovieVidios';


const VideoModel = ( {Moviename, tral_id }) => {
  useMovieVidios(tral_id);
  
  const trailervd = useSelector((store) => store.details?.ClipDetails)
  const dispatch = useDispatch();
 
  const closeModel =()=>{
    dispatch(togglePopUp())
  }
 
  return (<>
    <div className="justify-center  md: items-center flex overflow-x-scroll overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
    <div className="relative w-auto my-6 mx-auto max-w-3xl">
      {/*content*/}
      <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
        {/*header*/}
        <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
          <h3 className="text-3xl font-semibold">
             {Moviename}
          </h3>
          <button
            className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
            onClick={closeModel}
          >
            <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
              ×
            </span>
          </button>
        </div>
        {/*body*/}
        <div className="relative p-6 flex-auto">
        <iframe width="560" height="315" src={"https://www.youtube.com/embed/" +trailervd?.key  + "?si=XY0VBR97_3477Oyi"} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay ; mute; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen="true"></iframe>
        </div>
        {/*footer*/}
        <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
          <button
            className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            type="button"
           onClick={closeModel}
          >
            Close
          </button>
         
        </div>
      </div>
    </div>
  </div>
  <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
</>
  )
}

export default VideoModel